import VSelectCardPaymentMode from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardPaymentMode', VSelectCardPaymentMode),
};
